let overviewCounter = [];
let overviewCounterNum = [];
let overviewCounterID = [];
let overview = {
    init: function () {
        $('.global-network__overview-num li')
            .each(function (i) {
                $(this)
                    .find('.counter')
                    .attr('id', 'number0' + i);
                overviewCounterID[i] = $(this).find('.counter').attr('id');
                overviewCounterNum[i] = $(this).find('.counter').text();
            })
            .promise()
            .done(function () {
                overviewCounterID.forEach(function (item, index, array) {
                    let id = String(item);
                    let endNum = Number(overviewCounterNum[index]);
                    overviewCounter[index] = new CountUp(id, 0, endNum);
                });
            });
    },
    start: function () {
        overviewCounter.forEach(function (item, idx) {
            overviewCounter[idx].start();
        });
    },
};

const $branchSwiperBtnPrev = $(
    '.global-network__branch-swiper-buttons .btn-prev',
);
const $branchSwiperBtnNext = $(
    '.global-network__branch-swiper-buttons .btn-next',
);

let branchSet = function ($this) {
    for (let i in branchInfo) {
        let slide = `<div class='swiper-slide'>`;
        slide += `<a href='javascript:;' data-open-layered='${branchInfo[i].branchLayered}'>`;
        slide += `<img src='${branchInfo[i].branchImg}' alt=''>`;
        slide += `<div class="global-network__branch-tit">`;
        slide += `<span>${branchInfo[i].countryName}</span>${branchInfo[i].branchName}`;
        slide += `</div></a></div>`;
        $this.appendSlide(slide);
    }
    if (branchInfo.length < 2) {
        $('.global-network__branch-swiper--sub').hide();
        $('.swiper-scrollbar-lock, .swiper-pagination-lock').show();
        //$('.swiper-scrollbar-drag').css({ width: '100%' });
    }
};

let branchBtnActivation = function (idx) {
    if (idx == 0) {
        $branchSwiperBtnPrev.prop('disabled', true);
        $branchSwiperBtnNext.prop('disabled', false);
    } else if (idx == Object.keys(branchInfo).length - 1) {
        $branchSwiperBtnPrev.prop('disabled', false);
        $branchSwiperBtnNext.prop('disabled', true);
    } else {
        $branchSwiperBtnPrev.prop('disabled', false);
        $branchSwiperBtnNext.prop('disabled', false);
    }
};
const BranchSwiperMain = new Swiper(
    '.global-network__branch-swiper--main .swiper',
    {
        width: 830,
        slideActiveClass: 'is-active',
        //effect: 'fade',
        scrollbar: {
            el: '.global-network__branch-swiper-scrollbar',
            draggable: false,
        },
        pagination: {
            el: '.global-network__branch-swiper-pagination',
            type: 'fraction',
            formatFractionCurrent: function (number) {
                number = String(number);
                if (number.length < 2) number = '0' + number;
                return number;
            },
            formatFractionTotal: function (number) {
                number = String(number);
                if (number.length < 2) number = '0' + number;
                return number;
            },
        },
        on: {
            init: function (el) {
                branchSet(this);
            },
            slideChange: function (swiper) {
                // console.log('MainactiveIndex' + swiper.activeIndex);
                // console.log('MainrealIndex' + swiper.realIndex);
                BranchSwiperSub.slideToLoop(swiper.realIndex);
            },
        },
    },
);

const BranchSwiperSub = new Swiper('.global-network__branch-swiper--sub', {
    slidesPerView: 2,
    spaceBetween: 40,
    slideActiveClass: 'is-active',
    slideToClickedSlide: true,
    loop: true,
    on: {
        init: function () {
            branchSet(this);
            this.slideToLoop(0);
            $('.global-network__branch-swiper--sub .swiper-slide a').removeAttr(
                'data-open-layered',
            );
        },
        slideChange: function (swiper) {
            // console.log('SUBactiveIndex' + swiper.activeIndex);
            // console.log('SUBrealIndex' + swiper.realIndex);
            BranchSwiperMain.slideToLoop(swiper.realIndex);
            branchBtnActivation(swiper.realIndex);
        },
    },
});

// BranchSwiperMain.controller.control = BranchSwiperSub;
// BranchSwiperSub.controller.control = BranchSwiperMain;

const $gnHeader = $('.app-header');
const $gnNav = $('.app-header__gnb');
let gnPosition = {};
let gnCurrent = [];

const gn_scrollSpy = {
    init: function () {
        return new Promise(function (resolve, reject) {
            $gnNav.empty();
            $('.js_global-network-spy').each(function (i) {
                //Make GNB
                let title = $(this).find('.global-network__title').text();
                $gnNav.append(`<a href="javascript:;">${title}</a>`);

                //Section Position
                gnPosition[i] = parseInt($(this).offset().top);
            });
            resolve('Success!');
        }).then(function () {
            $gnNav.children('a:first-child').remove();
            gn_scrollSpy.trigger(gvr_st);
        });
    },
    trigger: function (st) {
        return new Promise(function (resolve, reject) {
            gnCurrent.length = 0;
            for (let top in gnPosition) {
                if (st + gvr_winH / 2 >= gnPosition[top]) {
                    gnCurrent.push(top);
                }
            }
            resolve('Success!');
        }).then(function () {
            if (gnCurrent.length) {
                let current = Math.max(...gnCurrent);
                $('.js_global-network-spy').eq(current).addClass('is-active');
                //console.log(current);
                if (current > 0) {
                    $gnNav
                        .children('a')
                        .eq(current - 1)
                        .addClass('is-current')
                        .siblings('a')
                        .removeClass('is-current');
                } else {
                    $gnNav.children('a').removeClass('is-current');
                }
                switch (current) {
                    case 0:
                        //$gnHeader.addClass('is-transparent');
                        break;
                    case 1:
                        //$gnHeader.removeClass('is-transparent');
                        overview.start();
                        break;
                    default:
                        //$gnHeader.removeClass('is-transparent');
                        break;
                }
            }
        });
    },
};

const gnHeaderSet = function () {
    if (gvr_st > 0) {
        $gnHeader.removeClass('is-transparent');
    } else {
        $gnHeader.addClass('is-transparent');
    }
};

$(document)
    .on('click', '.app-header__gnb a', function () {
        let idx = $(this).index();
        $scrollBody
            .stop()
            .animate({ scrollTop: gnPosition[idx + 1] - 80 + 'px' }, 200);
    })
    .on(
        'click',
        '.global-network__branch-swiper-buttons .btn-prev',
        function () {
            BranchSwiperMain.slidePrev();
        },
    )
    .on(
        'click',
        '.global-network__branch-swiper-buttons .btn-next',
        function () {
            BranchSwiperMain.slideNext();
        },
    )
    // 개발소스로 이관
    // .on('click', '.lx_post-navigation a', function () {
    //     if (!$(this).hasClass('is-disabled')) {
    //         $appLayered.scrollTop(0);
    //         gfn_layered.sizeCheck();
    //     }
    // })
    .on('click', '.global_network__history .lx_btn-view-more', function () {
        $('.global_network__history').find('ul').toggleClass('is-active');
        $('.global_network__history')
            .find('ul')
            .one('transitionend', function () {
                gn_scrollSpy.init();
            });
    });

$(window)
    .on('scroll', function () {
        gvr_st = $(this).scrollTop();
        gn_scrollSpy.trigger(gvr_st);
        gnHeaderSet();
    })
    .on('load', function () {
        overview.init();
        gn_scrollSpy.init();
        gn_scrollSpy.trigger(gvr_st);
        gnHeaderSet();
    });
